"use client";

// src/components/atoms/Button/Button.style.ts
import { tv } from "tailwind-variants";
var button = tv({
  base: "font-sans text-base flex justify-center items-center cursor-pointer font-medium leading-4 h-56 px-24 py-0 whitespace-nowrap rounded-4xl outline-2 outline outline-transparent",
  variants: {
    color: {
      primary: "bg-stone-500 text-display-0 hover:shadow-[0_0_4px_2px_rgba(66,236,154,0.5)] hover:bg-stone-600 disabled:border-display-200 disabled:bg-display-200 disabled:text-display-0 disabled:shadow-none disabled:cursor-not-allowed disabled:active:shadow-none disabled:active:bg-display-200 active:bg-stone-500 active:shadow-[0_0_4px_2px_rgba(66,236,154,0.5)]           focus:bg-stone-500 focus:shadow-[0_0_4px_2px_rgba(66,236,154,0.5)] focus-visible:bg-stone-500 focus-visible:shadow-[0_0_4px_2px_rgba(66,236,154,0.5)]            focus-within:bg-stone-500 focus-within:shadow-[0_0_4px_2px_rgba(66,236,154,0.5)]",
      secondary: "border-display-400 border-[1px] border-solid bg-white text-display-900 hover:shadow-[0_0_4px_2px_rgba(66,236,154,0.5)] active:border-stone-400 active:bg-stone-300",
      primaryNeon: "text-display-900 font-sans bg-stone-300 transition-shadow hover:bg-stone-400 hover:shadow-[0_0_4px_2px_rgba(66,236,154,0.5)] focus:bg-stone-300 focus:shadow-[0_0_4px_2px_rgba(66,236,154,0.5)] active:bg-stone-400 active:shadow-[0_0_8px_4px_rgba(15,204,125,0.3)]  disabled:text-display-0 disabled:bg-display-200 disabled:border disabled:border-solid disabled:border-display-200 disabled:shadow-none bg-stone-300 hover:bg-stone-400 hover:shadow-[0_0_4px_2px_rgba(66,236,154,0.5)]",
      ghost: "text-stone-900 bg-stone-50 hover:border-stone-50 hover:bg-stone-50 hover:text-display-900 hover:shadow-[0_0_4px_2px_rgba(66,236,154,0.5)] focus:border-display-300 focus:bg-display-0 focus:text-display-900 focus:shadow-[0_0_4px_2px_rgba(66,236,154,0.5)] active:border-stone-300 active:bg-stone-300 active:text-display-900 active:shadow-[0_0_4px_2px_rgba(66,236,154,0.5)]",
      transparent: "btn-transparent",
      ton: "bg-lime-300 text-display-700 active:bg-lime-500 active:shadow-[0_0_8px_4px_rgba(66,236,154,0.5)] focus:shadow-[0_0_8px_4px_rgba(66,236,154,0.5)] hover:bg-lime-400 hover:shadow-[0_0_4px_2px_rgba(66,236,154,0.5)]"
    },
    fullWidth: {
      true: "w-full",
      false: "inline-flex"
    }
  },
  defaultVariants: {
    color: "primary",
    fullWidth: false
  }
});
var link = tv({
  base: "flex gap-4 md:p-0 px-16 pb-8 w-max max-w-[620px] md:max-w-none text-[16px] font-medium leading-[24px] paragraph-16 whitespace-nowrap",
  variants: {
    color: {
      primary: "text-stone-700",
      secondary: "text-stone-300",
      primaryNeon: "text-stone-300",
      ghost: "text-black",
      transparent: "text-transparent",
      ton: "text-lime-300"
    }
  },
  defaultVariants: {
    color: "primary"
  }
});

export {
  button,
  link
};
